import spartaEventsUtility from "utilities/global/sparta-events-utility/2.3.2/js/sparta-events-utility";
import spartaGlobalFunctions from "utilities/global/sparta-global-functions-utility/2.1.1/js/sparta-global-functions-utility";
import _ from "utilities/vendor/lodash/4.13.1/js/lodash.custom.min";
import spartaMediaQueryUtility from "utilities/global/sparta-mediaquery-utility/2.0.2/js/sparta-mediaquery-utility";
import spartaStoreUtility from "utilities/global/sparta-store-utility/3.0.3/js/sparta-store-utility";
import spartaStyleUtility from "utilities/global/sparta-style-utility/3.1.5/js/sparta-style-utility";
import spartaPolyfillUtility from "utilities/global/sparta-polyfill-utility/1.5.1/js/sparta-polyfill-utility";
import spartaTemplatesUtility from "utilities/global/sparta-templates-utility/2.0.0/js/sparta-templates-utility";
import spartaBrowserSupportUtility from "utilities/global/sparta-browser-support-utility/4.3.0/js/sparta-browser-support-utility";
import spartaUILayersUtility from "utilities/global/sparta-ui-layers-utility/5.6.9/js/sparta-ui-layers-utility";
const EVENTS = {
  SPARTA_GLOBAL_READY: 'SPARTA_GLOBAL_READY.spartaBootstrapUtility',
  SPARTA_SECONDARY_READY : 'SPARTA_SECONDARY_READY.spartaBootstrapUtility',
  SPARTA_WINDOW_SCROLL: 'SPARTA_WINDOW_SCROLL.spartaBootstrapUtility'
};

class SpartaBootstrapUtility {
  constructor() {
    this.modules = [];
    this.initedModules = [];
    this.moduleInstances = [];
    this.appContainer = null;
    this.browser = spartaStoreUtility.getData('browser');
    this.loop = { total: 1, completed: 0 };
  }

  get EVENTS() {
    return EVENTS;
  }





  init(requireArgs = [], widgetInfo) {
    this.setupSpaParams(widgetInfo);
    this.setApplicationData(widgetInfo);
    this.loadOptionsFromContainer();
    this.checkForLangOverride();
    this.setupGlobalEvents();
    this.createAndInitModules(requireArgs);

    if (this.loop.total == 1) {
      spartaEventsUtility.pub(this.EVENTS.SPARTA_GLOBAL_READY);
    }
    if (this.loop.total == 2) {
      if (this.loop.completed === 0) {
        spartaEventsUtility.pub(this.EVENTS.SPARTA_GLOBAL_READY);
      }
      else if (this.loop.completed > 0) {
        spartaEventsUtility.pub(this.EVENTS.SPARTA_SECONDARY_READY);
      }
    }
  }

  setLoop(loopObj) {
    this.loop = loopObj;
  }

  setupSpaParams(widgetInfo) {
    let spaParams = widgetInfo && widgetInfo.name ?
      window.spaWidgetParams[widgetInfo.name][widgetInfo.version] :
      window.spaParams;


    spaParams.siteParams = spaParams.siteParams || spaParams.params;

    spartaStoreUtility.addData('spaParams', spaParams);
    spartaEventsUtility.pub(spartaEventsUtility.EVENTS.SPA_PARAMS_LOADED, spaParams);
  }

  setApplicationData(widgetInfo) {
    let appContainer;
    let mediaQueryContainer;

    let isWidget = !!(widgetInfo && widgetInfo.name && widgetInfo.version);
    spartaStoreUtility.addData('isWidget', isWidget);

    if (isWidget) {
      let widgetContainers = document.querySelectorAll(`[data-sparta-container="${widgetInfo.name}"][data-version="${widgetInfo.version}"]`);

      mediaQueryContainer = document.querySelector(`[data-sparta-wrapper="${widgetInfo.name}-${widgetInfo.version}"]`);

      if (widgetContainers) {

        if (widgetContainers.length === 1) {
          appContainer = widgetContainers[0];
        } else if (widgetContainers.length > 1) {
          const widgetWithId = [...widgetContainers].filter(el => el.getAttribute('data-id') === widgetInfo.id);
          appContainer = (widgetWithId && widgetWithId[0]) || widgetContainers;
        }
      }

      if (mediaQueryContainer && mediaQueryContainer.length) {
        mediaQueryContainer = mediaQueryContainer[0];
      }

      spartaStoreUtility.addData('applicationContext', widgetInfo);
    }

    spartaEventsUtility.pub(spartaEventsUtility.EVENTS.APP_CONTEXT_LOADED, spartaStoreUtility.getData('applicationContext'));

    if (!appContainer) {
      let topContainer = document.querySelectorAll(`[data-sparta-container]`);

      mediaQueryContainer = document.querySelector(`[data-sparta-wrapper]`);

      if (!topContainer) {
        console.error('unable to find a sparta component - ensure data-sparta-container is set');
        return;
      } else {
        topContainer = [...topContainer].filter(el => !el.classList.contains('sparta-widget-container'));

        if (topContainer.length !== 1) {
          console.error('too many containers on page, must use widget configuration or loader');
          return;
        }
      }

      appContainer = topContainer[0];
    }

    this.appContainer = appContainer;
    spartaMediaQueryUtility.init(mediaQueryContainer || appContainer);

    this.appContainer = this.appContainer.length ? [].slice.call(this.appContainer) : this.appContainer;

    spartaStoreUtility.addData('applicationContainer', this.appContainer);
    spartaEventsUtility.pub(spartaEventsUtility.EVENTS.APP_CONTAINER_LOADED, appContainer);
  }





  loadOptionsFromContainer() {
    const appContainer = spartaStoreUtility.getData('applicationContainer');
    const containers = [].slice.call(Array.isArray(appContainer) ? appContainer : [appContainer]);
    const optionsObj = JSON.parse(containers[containers.length - 1].getAttribute('data-sparta-options')) || {};
    spartaStoreUtility.addData('applicationOptions', optionsObj);
  }




  checkForLangOverride() {
    const containers = spartaStoreUtility.getData('applicationContainer');
    const appContainer = [].slice.call(Array.isArray(containers) ? containers : [containers]);
    const langOverride = appContainer && appContainer[appContainer.length - 1].getAttribute('data-sparta-lang') || null;

    if (langOverride) {
      spartaStoreUtility.addData('lang', langOverride.toLowerCase());
    }
  }





  createModuleInstances(requireArgs) {
    const containers = spartaStoreUtility.getData('applicationContainer');
    const applicationContainer = Array.isArray(containers) ? containers[containers.length-1] : containers;
    const boaModules = this._getUninitializedModules([...applicationContainer.querySelectorAll('[data-component="module"]')]);
    const deps = [...requireArgs];
    const depModuleMap = {};

    deps.forEach(dep => {
      if (!dep || typeof(dep.default) !== 'function') { return; }
      const name = dep.default.toString().match(/^function\s*([^\s(]+)/)[1];
      depModuleMap[name] = dep;
    });

    boaModules.forEach(moduleDom => {
      const className = moduleDom.getAttribute('data-init');

      if (className) {
        const module = depModuleMap[className];


        const options = JSON.parse(moduleDom.getAttribute('data-options')) || {};


        options.target = moduleDom;


        if (!this.moduleInstances[className]) { this.moduleInstances[className] = []; }
        if(module !== undefined){
          this.moduleInstances[className].push(new module.default(options));
        }



        moduleDom.classList.remove('spa-module-init');
      }
    });

    spartaStoreUtility.addData('moduleInstances', this.moduleInstances);
  }





  verifyUniqueModuleIds(module) {
    if (!module.settings.target || !module.settings.target.id) {
      return;
    }

        const moduleContainers = document.querySelectorAll(`[id="${module.settings.target.id}"]`);

        if (moduleContainers && moduleContainers.length > 1) {
      let imSettings, mSettings = module.settings;
      this.initedModules.reverse().every((im) => {
        imSettings = im.module.settings;
        if (imSettings.moduleInfo
            && imSettings.moduleInfo.name === mSettings.moduleInfo.name
            && imSettings.target.id.startsWith(mSettings.target.id)) {

          mSettings.target.totalInstances = (imSettings.target.totalInstances || 0) + 1;


          delete imSettings.target.totalInstances;


          mSettings.target.id = mSettings.target.id + mSettings.target.totalInstances;
          return false;
        }
        return true;
      });
    }
  }




  initModules() {
    this.modules.forEach(module => {
      if (module.state === 'ready') {

                this.verifyUniqueModuleIds(module.module);

        module.module[module.init](module.args);
        module.state = 'initialized';
        this.initedModules.push(module);
      }
    });
  }







  register(module, args = {}, init = 'init') {
    this.modules.push({
      state: 'ready',
      module,
      init,
      args,
    });
  }




  setupGlobalEvents() {

    window.addEventListener('scroll', _.throttle(e => {
      spartaEventsUtility.pub(this.EVENTS.SPARTA_WINDOW_SCROLL, [window.pageYOffset, e]);
    }, 20));
  }




  onloadHelpers() {
    const containers = spartaStoreUtility.getData('applicationContainer');
    const applicationContainer = Array.isArray(containers) ? containers[containers.length - 1] : containers;

    const spaFnElems = this._getUninitializedModules([...applicationContainer.querySelectorAll('.spa-fn')]);
    if (!spaFnElems.length) { return; }

    const onloadHelperRegister = ['.spa-boa-window', '.spa-mobile-tel'];

    onloadHelperRegister.forEach(helperClass => {
      if (helperClass === '.spa-mobile-tel' && !this.browser.mobile) {
        return;
      }
      const elsToProcess = this._getUninitializedModules(applicationContainer.querySelectorAll(`.spa-fn${helperClass}`));

      if (elsToProcess.length) {
        switch (helperClass) {
          case '.spa-boa-window':
            spartaUILayersUtility.addPopupWindowHelper(elsToProcess);
            break;
          case '.spa-mobile-tel':
            spartaGlobalFunctions.mobilePhoneFormatHelper(elsToProcess);
            break;
        }
      }
    }, this);
  }




  _getUninitializedModules(modules) {
    return _.filter(modules, (module) =>
      !_.find(this.initedModules, (initedModule) => initedModule.module.settings.target === module));
  }





  createAndInitModules(requireArgs) {

    this.createModuleInstances(requireArgs);
    this.initModules();


    this.onloadHelpers();
  }
}

export default new SpartaBootstrapUtility();
